// extracted by mini-css-extract-plugin
export default {"orderButton":"StripeDialog_orderButton__jj1L1","error":"StripeDialog_error__os4Xp"};